import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { matchRoutes, useLocation, useNavigate } from 'react-router-dom';
import { useAuthContext } from '@web/api/src';
import { Button, useClickOutsideHandler } from '@web/utils';
import { Cart, CartButton } from '../Cart';
import { Logo } from '../Logo';
import { NavigationLink } from '../NavLink';

const navitems = [
  {
    id: 0,
    link: '/',
    label: 'shop',
  },
  {
    id: 1,
    link: '/farm',
    label: 'farm',
  },
  {
    id: 2,
    link: '/prices',
    label: 'prices',
  },
  {
    id: 3,
    link: '/documents/:retailerId/orders',
    label: 'documents',
  },
];

const dissallowCartRoutes = [
  { path: '/order/:orderId/success' },
  { path: '/' },
];

const HeaderNavigation = () => {
  const [isAccountMenuOpen, setIsAccountMenuOpen] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const cartAllowedRoutes = matchRoutes(dissallowCartRoutes, location);
  const isHomePage = location.pathname === '/';
  const { logout } = useAuthContext();

  const accountMenuRef = useRef(null);

  useClickOutsideHandler(accountMenuRef, () => setIsAccountMenuOpen(false));
  const handleNavigation = (path) => {
    navigate(path);
    setIsAccountMenuOpen(false);
  };

  return (
    <>
      <nav className="items-center justify-between hidden mx-auto w-full h-8-0 md:flex relative top-0 bg-primary-white container">
        <Logo className="h-4-0" />
        <div className="flex gap-4-0 h-full items-center">
          {!isHomePage &&
            navitems.map((item) => (
              <NavigationLink key={item.id} to={item.link} label={item.label} />
            ))}
          <div className="flex relative" ref={accountMenuRef}>
            <Button
              variant="secondary"
              className="mr-2-0 z-2"
              onClick={() => setIsAccountMenuOpen((prev) => !prev)}
            >
              {t('navigation.account')}
            </Button>
            {isAccountMenuOpen && (
              <div className="absolute z-1 top-[100%] transform -translate-y-0-3 border border-primary-green border-t-0 left-0 bg-primary-white shadow rounded-base">
                <ul className="text-body1 text-primary-green">
                  <li
                    className=" pt-1-5 p-1-0 cursor-pointer hover:bg-primary-green hover:text-primary-white"
                    onClick={() => handleNavigation('/profile')}
                  >
                    {t('global.profile')}
                  </li>
                  <li
                    className=" p-1-0 cursor-pointer hover:bg-primary-green hover:text-primary-white"
                    onClick={() => logout('/login')}
                  >
                    {t('global.logout')}
                  </li>
                </ul>
              </div>
            )}
            <div className="w-7-0 flex justify-end">
              {!cartAllowedRoutes && <CartButton />}
            </div>
          </div>
        </div>
        <Cart />
      </nav>
    </>
  );
};

export default HeaderNavigation;
